"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spiritswap = void 0;
exports.spiritswap = {
    router: '0x16327E3FbDaCA3bcF7E38F5Af2599D2DDc33aE52',
    masterchef: '0x9083EA3756BDE6Ee6f27a6e996806FBD37F6F093',
    gaugeStaker: '0x44e314190D9E4cE6d4C0903459204F8E21ff940A',
    gaugeProxy: '0x420b17f69618610DE18caCd1499460EFb29e1d8f',
    feeDistributor: '0x18CeF75C2b032D7060e9Cf96F29aDF74a9a17ce6',
};
